module.exports = __webpack_public_path__ + "img/UploadArrow.b8989a1a.svg";